// helpers
import { useState } from 'react';
import { login as loginApi , afterlogin} from '../../helpers';
import { APICore, setAuthorization } from '../../helpers/api/apiCore';
import { useNavigate } from 'react-router-dom'; // Import the necessary functions from React Router



export  default function useLogin() {
    const api = new APICore();
    const AUTH_SESSION_KEY = 'shield_user';
    const navigate = useNavigate(); // Hook for navigation


    const [user, setUser] = useState();
    const [role, setRole] = useState();
    const [error, setError] = useState<any>();


    

    const login = async ({ id_aplikasi, id_user,username, kode_cabang,person_area,note,panel,hak_akses_desc, hak_akses, nama_jabatan, nama,email }: { id_aplikasi:string, id_user:string,username:string, kode_cabang:number,person_area:string,note:string,panel:string,hak_akses_desc:string, hak_akses: string, nama_jabatan:string, nama:string,email:string }) => {
        try {
             const response = await afterlogin({ id_aplikasi, id_user,kode_cabang, person_area, note,panel,hak_akses, hak_akses_desc, username, nama, nama_jabatan,email });
                setRole(response.data);
                api.setLoggedInUser(response.data);
                setAuthorization(response.data);
            
        } catch (error) {
            setError(error)
        }
       

       
    };
    const prelogin = async ({ username, password }: { username: string; password: string }) => {
        const response = await loginApi({ username, password });
        try {
        const response = await loginApi({ username, password });
        if (response.data?.kode === "S") {
            setError(null);
            setUser(response.data); // Update the user state
            return response.data;
        } else {
            setError(response.data?.pesan);
        }
    } catch (e) {
        setError(e);
    }
    };

    

    return [user, error, role,login,prelogin];
}


